
import { useState, useCallback } from 'react';

/**
 * useControllerModals
 * 
 * Manages the state for various modals in the ControllerPage and the Event Editor logic.
 */
export const useControllerModals = () => {
  const [modals, setModals] = useState({
    settings: false,
    info: false,
    schedule: false,
    event: false,
    share: false
  });

  const [eventEditor, setEventEditor] = useState({ rowIndex: null, messages: [] });
  const [editingInfoText, setEditingInfoText] = useState('');

  const toggleModal = useCallback((modalName, isOpen) => {
    setModals(prev => ({ ...prev, [modalName]: isOpen }));
  }, []);

  const openModal = useCallback((modalName) => toggleModal(modalName, true), [toggleModal]);
  const closeModal = useCallback((modalName) => toggleModal(modalName, false), [toggleModal]);

  const handleEditEvent = useCallback((rowIndex, eventsForThisRow) => {
    const transformedMessages = eventsForThisRow.map(event => ({
      id: Math.random(),
      text: event.message
    }));
    setEventEditor({ rowIndex, messages: transformedMessages });
    openModal('event');
  }, [openModal]);

  return {
    modals,
    setModals, // Keeping this for backward compatibility with ControllerModals component which expects setModals
    openModal,
    closeModal,
    toggleModal,
    eventEditor,
    setEventEditor,
    editingInfoText,
    setEditingInfoText,
    handleEditEvent
  };
};
